import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import { close } from '../../../modules/modal/actions';
import { BETTING_BUDDY, SAVED_SLIPS } from '../../../routes/paths';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCardSmall } = contentStackImageUrls;

export const CompleteYourBet = ({ closeModal, history }) => {
  const clickBuildBet = () => {
    history.push(BETTING_BUDDY);
    closeModal();
  };

  const clickViewSavedSlips = () => {
    history.push(SAVED_SLIPS);
    closeModal();
  };

  return (
    <div className="modal complete-bet">
      <div className="complete-bet__header">Complete Your Bet!</div>
      <p className="complete-bet__paragraph">
        Call in shop and scan the barcode on the back of your PLUS card
      </p>
      <p className="complete-bet__paragraph">
        <img
          className="complete-bet__image"
          src={plusCardSmall}
          onError={(e) => { e.target.src = '../../../../assets/images/plus-card-small.png'; }}
        />
      </p>
      <div className="modal__responsive-buttons">
        <Button
          className="modal__button"
          onClick={clickBuildBet}
        >
          Build Another Slip
        </Button>
        <Button
          className="modal__button button--secondary"
          onClick={clickViewSavedSlips}
        >
          View Saved Slips
        </Button>
      </div>
    </div>
  );
};

CompleteYourBet.propTypes = {
  closeModal: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const mapDispatchToProps = {
  closeModal: close
};

export default withRouter(connect(null, mapDispatchToProps)(CompleteYourBet));
